import React from 'react';
import { Controller } from 'react-hook-form';
import { Col, FormGroup, Input, Label } from 'reactstrap';

export const Text = ({
  control,
  label,
  fieldName,
  placeholder,
  size,
  onChange,
  value,
  readOnly,
}) => {
  return (
    <Col lg={size}>
      <FormGroup>
        <label className='form-control-label' htmlFor='input-first-name'>
          {label}
        </label>
        {control && (
          <Controller
            name={fieldName}
            control={control}
            render={({ field: { onChange, value } }) => (
              <Input
                className='form-control-alternative'
                id='input-first-name'
                placeholder={placeholder}
                type='text'
                onChange={onChange}
                value={value}
                readOnly={readOnly}
                autoComplete='off'
              />
            )}
          />
        )}
        {onChange && (
          <>
            <Input
              className='form-control-alternative'
              id='input-first-name'
              placeholder={placeholder}
              type='text'
              onChange={onChange}
              value={value}
              name={fieldName}
              autoComplete='off'
            />
          </>
        )}
        {!control && !onChange && (
          <>
            <Input
              className='form-control-alternative'
              id='input-first-name'
              placeholder={placeholder}
              type='text'
              onChange={onChange}
              value={value}
              name={fieldName}
              autoComplete='off'
            />
          </>
        )}
      </FormGroup>
    </Col>
  );
};

export const Checkbox = ({
  style,
  getValues,
  setValue,
  watch,
  field,
  textEnable,
  textDisable,
  size,
  value,
  onChange,
}) => {
  return (
    <Col lg={size} style={style}>
      <FormGroup>
        {getValues && (
          <>
            <Input
              className='form-control-alternative'
              id='input-first-name'
              type='checkbox'
              checked={getValues(field)}
              onChange={(e) => setValue(field, e.target.checked)}
            />
            <Label>{watch(field) ? textEnable : textDisable}</Label>
          </>
        )}
        {onChange && (
          <>
            <Input
              className='form-control-alternative'
              id='input-first-name'
              type='checkbox'
              name='enable'
              title='Ativo'
              onChange={onChange}
              checked={value}
            />{' '}
            <Label>Ativo</Label>
          </>
        )}
      </FormGroup>
    </Col>
  );
};

export const Select = ({ label, size, control, fieldName, disabled, data }) => {
  return (
    <Col lg={size}>
      <FormGroup>
        <Label for={`select-custom-${label}`}>{label}</Label>
        <Controller
          name={fieldName}
          control={control}
          render={({ field: { onChange, value } }) => (
            <Input
              id={`select-custom-${label}`}
              name='select'
              type='select'
              className='form-control-alternative'
              onChange={onChange}
              value={value}
              disabled={disabled}
            >
              {data.map((field) => (
                <option id={field.id} value={field.value}>
                  {field.name}
                </option>
              ))}
            </Input>
          )}
        />
      </FormGroup>
    </Col>
  );
};

export const SelectWihoutControl = ({
  label,
  size,
  disabled,
  data,
  onChange,
  value,
}) => {
  return (
    <Col lg={size}>
      <FormGroup>
        <Label for={`select-custom-${label}`}>{label}</Label>
        <Input
          id={`select-custom-${label}`}
          name='select'
          type='select'
          className='form-control-alternative'
          onChange={onChange}
          value={value}
          disabled={disabled}
        >
          {data.map((field) => (
            <option id={field.id} value={field.value}>
              {field.name}
            </option>
          ))}
        </Input>
      </FormGroup>
    </Col>
  );
};
